class ImageCarousel extends HTMLElement {
  constructor() {
    super()

    this.splideElement = this.querySelector('.splide')
    this.interval = this.splideElement.getAttribute('data-interval') || 1
    this.autoplay = this.splideElement.getAttribute('data-autoplay')

    const splide = new Splide(this.splideElement, {
      type: 'loop',
      drag: true,
      arrows: true,
      autoWidth: true,
      autoHeight: true,
      lazyLoad: 'nearby',
      pagination: false,
      preloadPages: 3,
      perPage: 1,
      autoScroll: {
        autoStart: false,
        speed: Number(this.interval),
      },
    })

    if (this.autoplay == 'true') {
      splide.mount(window.splide.Extensions)
    } else {
      splide.mount()
    }

  }
}

customElements.define('image-carousel', ImageCarousel)
